<template>
    <div id="mainbody" ref="mainbody"  :style="{maxWidth:screenWidth}">
        <h3>RMA Form</h3>
        <el-form :model="rmaForm" :rules="rules" ref="rmaFormRef" class="dataTables_list" >

            <el-collapse v-model="activeNames" >
                <el-row>
                    <el-col :span="15">
                        <el-collapse-item  title="Customer Information" name="1" class="customer-account-header" >
                            <table class="customer-account">
                                <tr>
                                    <td>RMA Applicant<span class="bixu">*</span></td>
                                    <td><el-input   v-model="rmaForm.application" ></el-input></td>
                                    <td>Phone<span class="bixu">*</span></td>
                                    <td><el-input   v-model="rmaForm.phone" ></el-input></td>
                                </tr>
                                <tr>
                                    <td>Company<span class="bixu">*</span></td>
                                    <td><el-input   v-model="rmaForm.company" ></el-input></td>
                                    <td>E-mail address<span class="bixu">*</span></td>
                                    <td><el-input   v-model="rmaForm.email" ></el-input></td>
                                </tr>
                                <tr>
                                    <td>Country<span class="bixu">*</span></td>
                                    <td><el-input   v-model="rmaForm.country" ></el-input></td>
                                    <td>Code<span class="bixu">*</span></td>
                                    <td><el-input   v-model="rmaForm.code" ></el-input></td>
                                </tr>
                            </table>
                        </el-collapse-item>
                    </el-col>
                    <el-col :span="9">
                        <el-collapse-item  title="RMA Status" name="2" class="rma-status-header">
                            <table class="customer-account">
                                <tr>
                                    <td>RMA Submit Date</td>
                                    <td><el-input  disabled v-model="rmaForm.create_time" ></el-input></td>
                                </tr>
                                <tr>
                                    <td>*RMA Status</td>
                                    <td>
                                        <el-select  v-model="rmaForm.status" placeholder="please choose">
                                            <el-option label="RMA Reported" value='0'> </el-option>
                                            <el-option label="BTI Wireless Response" value='1'> </el-option>
                                            <el-option label="Return to BTI Wireless" value='2'> </el-option>
                                            <el-option label="Analysis&Repair" value='3'> </el-option>
                                            <el-option label="Return to Customer" value='4'> </el-option>
                                        </el-select>

                                    </td>
                                </tr>
                                <tr>
                                    <td>RMA Closed Date</td>
                                    <td>
                                        <el-date-picker
                                                disabled
                                                v-model="rmaForm.close_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>

                                    </td>
                                </tr>
                            </table>
                        </el-collapse-item>
                    </el-col>


                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="24">

                        <el-collapse-item title="RMA Submission Detail (by Customer)" name="3" class="userinput">
                            <table class="customer-account product-details">
                                <tr>
                                    <th class="bgred">Product Name <span class="bixu">*</span></th>
                                    <th class="bgred">Serial Number <span class="bixu">*</span></th>
                                    <th class="bgred">Fault Category</th>
                                    <th  class="bgred" width="25%">Fault Description <span class="bixu">*</span></th>
                                    <th>File Download</th>

                                </tr>
                                <tr v-for="(itemp,index) in rmaForm.product" >
                                    <td><el-input   v-model="itemp.product_name" ></el-input></td>
                                    <td><el-input   v-model="itemp.serial_number" ></el-input></td>
                                    <td><el-select  v-model="itemp.faulty_category" placeholder="please choose">
                                        <el-option
                                                v-for="item in setForm.faulty_category"
                                                :label="item"
                                                :value="item">
                                        </el-option>

                                    </el-select>
                                    </td>
                                    <td>
                                        <!--<TextareaAutosize class="tsize" v-model="itemp.faulty_description" :min-height="24" :max-height="350" />-->
                                 <el-input   v-model="itemp.faulty_description" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input>



                                    <td>
                                        <el-upload
                                                class="upload-demo"
                                                :action="geturl()"
                                                :headers="myHeaders"
                                                :limit="1"
                                                :on-remove="( file, fileList)=>handleRemove1( file, fileList,index,'file_upload')"
                                                :on-success="(response, file, fileList)=>handleSuccess1(response, file, fileList,index,'file_upload')"
                                                :before-remove="beforeRemove1"
                                                :multiple=true
                                                :on-exceed="handleExceed1"
                                                :file-list="itemp.file_upload_list">
                                            <el-button    size="small" type="primary" ><i class="el-icon-upload"></i></el-button>
                                        </el-upload>
                                        <el-button   size="small" @click="downloaddocs('file_upload',itemp.id)"><i class="el-icon-download"></i></el-button>

                                    </td>


                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" >
                    <el-col :span="12">

                        <el-collapse-item title="Shipping Details" name="3"  class="userinput" >
                            <table class="customer-account product-details">
                                <tr>
                                    <th>Address <span class="bixu">*</span></th>
                                    <th>Contact Name <span class="bixu">*</span></th>
                                    <th>Phone Number <span class="bixu">*</span></th>
                                </tr>
                                <tr>
                                    <td><el-input  v-model="rmaForm.rma_address" ></el-input></td>
                                    <td><el-input   v-model="rmaForm.contact_name" ></el-input></td>
                                    <td><el-input  v-model="rmaForm.phone_number" ></el-input></td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" class="removediv" >
                    <el-col :span="12">

                        <el-collapse-item title="Customer Information" name="4" class="color-green">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>RMA Number</th>
                                    <th>Items Registered</th>
                                </tr>

                                <tr>
                                    <td><el-input :disabled="role===3"  v-model="rmaForm.rma_number" ></el-input></td>
                                    <td><el-input :disabled="role===3"  v-model="rmaForm.items_registered" ></el-input></td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="24">

                        <el-collapse-item title="RMA Information" name="5" class="color-green">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>RMA Number</th>
                                    <th>Product Name</th>
                                    <th>Serial Number</th>
                                    <th>RMA Solution</th>
                                    <th>Information</th>
                                    <th>Requirement</th>
                                    <th>Warranty Status</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td>

                                        <el-input  :disabled="role===3" v-model="itemp.rma_number" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input>
                                    </td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.product_name" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.serial_number" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td>
                                        <el-select :disabled="role===3"  v-model="itemp.rma_solution" placeholder="please choose" @change="((val)=>{solutionchange(val, index)})"  >
                                            <el-option

                                                    v-for="item in setForm.rma_solution"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </td>

                                    <td><el-input :disabled="role===3"  v-model="itemp.delivery_information" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.packing_requierment" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td>
                                        <el-select :disabled="role===3" v-model="itemp.warranty_status" placeholder="please choose">
                                            <el-option
                                                    v-for="item in setForm.warranty_status"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20"  class="removediv">
                    <el-col :span="24">

                        <el-collapse-item title="Shipping Tracker (Customer→BTI Wireless)" name="6">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>Responsible Party</th>
                                    <th>RMA Number(s)</th>
                                    <!--<th class="bgred">Delivery information</th>-->
                                    <th class="bgred">Deliver/ Pickup Date</th>
                                    <th class="bgred">Invoice/Packing List</th>
                                    <th class="bgred">Tracking#/AWB</th>
                                    <th>Received Date</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td> <el-select  :disabled="role===3" v-model="itemp.responsible" placeholder="please choose">
                                            <el-option
                                                    v-for="item in setForm.responsible"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.serail_no" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <!--<td><el-input :disabled="role!==3"  v-model="itemp.user_delivery_information" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>-->
                                    <td>
                                        <el-input  v-model="itemp.pickup_ready" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>



                                    <td>
                                        <el-upload
                                                class="upload-demo"
                                                :action="geturl()"
                                                :headers="myHeaders"
                                                :limit="1"
                                                :on-remove="( file, fileList)=>handleRemove1( file, fileList2,index,'inv_pl')"
                                                :on-success="(response, file, fileList)=>handleSuccess1(response, file, fileList2,index,'inv_pl')"
                                                :before-remove="beforeRemove1"
                                                :multiple=true
                                                :on-exceed="handleExceed1"
                                                :file-list="itemp.inv_pl_list">
                                            <el-button    size="small" type="primary" ><i class="el-icon-upload"></i></el-button>
                                        </el-upload>
                                        <el-button   size="small" @click="downloaddocs('inv_pl',itemp.id)"><i class="el-icon-download"></i></el-button>
                                    </td>


                                    <td>
                                        <div style="width: 50%;float: left">


                                            <el-upload
                                                    class="upload-demo"
                                                    :action="geturl()"
                                                    :headers="myHeaders"
                                                    :limit="1"
                                                    :on-remove="( file, fileList)=>handleRemove1( file, fileList4,index,'tracking')"
                                                    :on-success="(response, file, fileList)=>handleSuccess1(response, file, fileList4,index,'tracking')"
                                                    :before-remove="beforeRemove1"
                                                    :multiple=true
                                                    :on-exceed="handleExceed1"
                                                    :file-list="itemp.tracking_list">
                                                <el-button    size="small" type="primary" ><i class="el-icon-upload"></i></el-button>
                                            </el-upload>
                                            <el-button   size="small" @click="downloaddocs('tracking',itemp.id)"><i class="el-icon-download"></i></el-button>
                                        </div>
                                        <div style="width: 50%;float: left">
                                            <el-input   v-model="itemp.user_delivery_information" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input>
                                        </div>
                                    </td>
                                    <td>
                                        <el-date-picker
                                                :disabled="role===3"
                                                v-model="itemp.received_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="removediv" >
                    <el-col :span="24">
                        <div>
                            <p> If you are responsible for shipping the unit to our repair center, please fill in this chart after shipment, so that we could prepare the customs clearance in advance.</p>
                            <p> If the responsible party is BTI Wireless, it means that we will arrange shipment for the unit return. Please fill in the date of pick up ready, and upload the Invoice/Packing List.</p>

                        </div>
                    </el-col>
                </el-row>



                <el-row :gutter="20" :hidden="role===3" class="removediv">
                    <el-col :span="24">
                        <el-collapse-item title="FAULT ASSESSMENT & SOLUTION (Internal user Only)" name="7" class="color-red">
                            <table class="customer-account  product-details">
                                <tr>
                                    <th style="max-width: 80px">RMA Number</th>
                                    <th style="max-width: 70px">Assessment Date</th>
                                    <th >Assessment Result</th>
                                    <!--<th>Possible Cause</th>-->
                                    <th>Parts Replaced</th>
                                    <!--<th>Customer Response</th>-->
                                    <th>Type of Cause</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td style="max-width: 80px"><el-input type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"  :disabled="role===3" v-model="itemp.serail_no" ></el-input></td>
                                    <td style="max-width: 60px">
                                        <el-date-picker

                                                :disabled="role===3"
                                                v-model="itemp.assessment_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.assessment_result" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <!--<td><el-input :disabled="role===3"  v-model="itemp.possible_cause" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>-->
                                    <td><el-input :disabled="role===3"  v-model="itemp.parts_replaced" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <!--<td><el-input :disabled="role===3"  v-model="itemp.customer_response" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>-->
                                    <td style="max-width: 50px">
                                        <el-select :disabled="role===3" v-model="itemp.type_of_cause" placeholder="please choose">
                                            <el-option
                                                    v-for="item in setForm.type_of_cause"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </td>
                                </tr>


                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="24">

                        <el-collapse-item title="Progress Update (For Customer Feedback)" name="8">
                            <table class="customer-account product-details">
                                <tr>
                                    <th style="max-width: 60px">Update Date</th>
                                    <!--<th>Update by</th>-->
                                    <th  style="max-width: 80px">RMA Number</th>
                                    <th>Servicing Record </th>
                                    <th>Corrective Action</th>
                                    <th  style="max-width: 80px">Estimated Return Date</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td  style="max-width: 60px">
                                        <el-date-picker
                                                :disabled="role===3"
                                                v-model="itemp.progress_update_user_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                    <!--<td><el-input  :disabled="role===3" v-model="itemp.update_by"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>-->
                                    <td style="max-width: 80px"><el-input :disabled="role===3"  v-model="itemp.serail_no"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.servicing_record"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.corrective_action"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td  style="max-width: 80px">
                                        <el-date-picker
                                                :disabled="role===3"
                                                v-model="itemp.estimated_return_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" class="removediv" >
                    <el-col :span="24">
                        <el-collapse-item title="Shipping Tracker (BTI Wireless→Customer)" name="9">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>Responsible Party</th>
                                    <th>RMA Number(s)</th>
                                    <!--<th class="bgred">Delivery information</th>-->
                                    <th>Deliver/ Pickup Date</th>
                                    <th>Invoice/Packing List</th>
                                    <th>Tracking#/AWB</th>
                                    <th class="bgred">Received Date</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product"  >


                                    <td>
                                        <el-select :disabled="role===3||rmaForm.status<3"  v-model="itemp.responsible2" placeholder="please choose">
                                            <el-option
                                                    v-for="item in setForm.responsible"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                       </td>
                                    <td><el-input :disabled="role===3||rmaForm.status<3"  v-model="itemp.serail_no"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <!--<td><el-input :disabled="role!==3||rmaForm.status<3" v-model="itemp.user_delivery_information2"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>-->
                                    <td><el-input  :disabled="role===3||rmaForm.status<3"  v-model="itemp.pickup_ready2"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td>

                                        <el-upload
                                                :disabled="role===3||rmaForm.status<3"
                                                class="upload-demo"
                                                :action="geturl()"
                                                :headers="myHeaders"
                                                :limit="1"
                                                :on-remove="( file, fileList)=>handleRemove1( file, fileList,index,'delivery_docs')"
                                                :on-success="(response, file, fileList)=>handleSuccess1(response, file, fileList,index,'delivery_docs')"
                                                :before-remove="beforeRemove1"
                                                :multiple=true
                                                :on-exceed="handleExceed1"
                                                :file-list="itemp.delivery_docs_list">
                                            <el-button    size="small" type="primary" ><i class="el-icon-upload"></i></el-button>
                                        </el-upload>
                                        <el-button   size="small" @click="downloaddocs('delivery_docs',itemp.id)"><i class="el-icon-download"></i></el-button>
                                    </td>
                                    <td>
                                        <div style="width: 50%;float: left">
                                            <el-upload
                                                    :disabled="rmaForm.status<3"
                                                    class="upload-demo"
                                                    :action="geturl()"
                                                    :headers="myHeaders"
                                                    :limit="1"
                                                    :on-remove="( file, fileList)=>handleRemove1( file, fileList3,index,'tracking2')"
                                                    :on-success="(response, file, fileList)=>handleSuccess1(response, file, fileList3,index,'tracking2')"
                                                    :before-remove="beforeRemove1"
                                                    :multiple=true
                                                    :on-exceed="handleExceed1"
                                                    :file-list="itemp.tracking2_list">
                                                <el-button    size="small" type="primary" ><i class="el-icon-upload"></i></el-button>
                                            </el-upload>
                                            <el-button   size="small" @click="downloaddocs('tracking2',itemp.id)"><i class="el-icon-download"></i></el-button>
                                        </div>
                                        <div style="width: 50%;float: left">
                                            <el-input   v-model="itemp.user_delivery_information2" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input>
                                        </div>
                                    <td>
                                        <el-date-picker
                                                :disabled="rmaForm.status<3"
                                                v-model="itemp.user_received_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" class="removediv" >
                    <el-col :span="24">

                        <el-collapse-item title="Correspondence Register" name="10">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>Entry Date</th>
                                    <th>Entered by</th>
                                    <th>Questions</th>
                                    <th>Response</th>
                                    <th>What is this field for?</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td style="width: 130px">
                                        <el-date-picker

                                                v-model="itemp.entry_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                    <td><el-input  v-model="itemp.entered_by"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td><el-input   v-model="itemp.questions"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td><el-input   v-model="itemp.response"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td><el-input   v-model="itemp.customer_accept"  type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>
            </el-collapse>
        </el-form>
        <span slot="footer" class="dialog-footer " >

            <el-button type="primary" @click="add" :disabled="submiting">SUBMIT</el-button>

             <el-button type="primary" @click="dialogVisible=true" > Generate Report</el-button>

        </span>
        <el-dialog
                :visible.sync="dialogVisible"
                width="100%"
                >
            <div  ref="pdfhtml" id="pdfdiv">
                <el-collapse  v-model="activeNames">
                    <el-row>
                        <el-col :span="15">
                            <el-collapse-item  title="Login Customer Account" name="1" class="customer-account-header" >
                                <table class="customer-account">
                                    <tr>
                                        <td>RMA Application <span class="bixu">*</span></td>
                                        <td><el-input   v-model="rmaForm.application" ></el-input></td>
                                        <td>Phone <span class="bixu">*</span></td>
                                        <td><el-input   v-model="rmaForm.phone" ></el-input></td>
                                    </tr>
                                    <tr>
                                        <td>Company <span class="bixu">*</span></td>
                                        <td><el-input   v-model="rmaForm.company" ></el-input></td>
                                        <td>Code <span class="bixu">*</span></td>
                                        <td><el-input   v-model="rmaForm.code" ></el-input></td>
                                    </tr>
                                    <tr>
                                        <td>Country <span class="bixu">*</span></td>
                                        <td><el-input   v-model="rmaForm.country" ></el-input></td>
                                    </tr>
                                </table>
                            </el-collapse-item>
                        </el-col>
                        <el-col :span="9">
                            <el-collapse-item  title="RMA Status" name="2" class="rma-status-header">
                                <table class="customer-account">
                                    <tr>
                                        <td>RMA Submit Date</td>
                                        <td><el-input  disabled v-model="rmaForm.create_time" ></el-input></td>
                                    </tr>
                                    <tr>
                                        <td>*RMA Status</td>
                                        <td>
                                            <el-select  v-model="rmaForm.status" placeholder="please choose">
                                                <el-option label="RMA Reported" value='0'> </el-option>
                                                <el-option label="BTI Wireless Response" value='1'> </el-option>
                                                <el-option label="Return to BTI Wireless" value='2'> </el-option>
                                                <el-option label="Analysis&Repair" value='3'> </el-option>
                                                <el-option label="Return to Customer" value='4'> </el-option>
                                            </el-select>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td>RMA Closed Date</td>
                                        <td>
                                            <el-date-picker
                                                    disabled
                                                    v-model="rmaForm.close_date"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="select date">
                                            </el-date-picker>

                                        </td>
                                    </tr>
                                </table>
                            </el-collapse-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" >
                        <el-col :span="24">

                            <el-collapse-item title="RMA Submission Detail (by Customer)" name="3" class="userinput printMe">
                                <table class="customer-account product-details">
                                    <tr>
                                        <th class="bgred">Product Name <span class="bixu">*</span></th>
                                        <th class="bgred">Serial Number <span class="bixu">*</span></th>
                                        <th class="bgred">Fault Category</th>
                                        <th  class="bgred" width="25%">Fault Description <span class="bixu">*</span></th>
                                    </tr>
                                    <tr v-for="(itemp,index) in rmaForm.product" >
                                        <td>{{itemp.product_name}}</td>
                                        <td>{{itemp.serial_number}}</td>
                                        <td><el-select  v-model="itemp.faulty_category" placeholder="please choose">
                                            <el-option
                                                    v-for="item in setForm.faulty_category"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>

                                        </el-select>
                                        </td>
                                        <td>{{itemp.faulty_description}}</td>


                                    </tr>

                                </table>
                            </el-collapse-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="12">

                            <el-collapse-item title="Shipping Details" name="3"  class="userinput printMe" >
                                <table class="customer-account product-details">
                                    <tr>
                                        <th>Address <span class="bixu">*</span></th>
                                        <th>Contact Name <span class="bixu">*</span></th>
                                        <th>Phone Number <span class="bixu">*</span></th>
                                    </tr>

                                    <tr>
                                        <td>{{rmaForm.rma_address}}</td>
                                        <td>{{rmaForm.contact_name}}</td>
                                        <td>{{rmaForm.phone_number}}</td>
                                    </tr>

                                </table>
                            </el-collapse-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" >
                        <el-col :span="24">

                            <el-collapse-item title="RMA Response(by BTI Wireless)" name="5" class="color-green printMe" >
                                <table class="customer-account product-details">
                                    <tr>
                                        <th>RMA Number</th>
                                        <th>Product Name</th>
                                        <th>Serial Number</th>
                                        <th>RMA Solution</th>
                                        <th>Delivery information</th>
                                        <!--<th>Packing requierment</th>-->
                                        <th>Warranty Status</th>
                                    </tr>

                                    <tr  v-for="(itemp,index) in rmaForm.product">
                                        <td>{{itemp.rma_number}}</td>
                                        <td>{{itemp.product_name}}</td>
                                        <td>{{itemp.serial_number}}</td>
                                        <td>
                                            <el-select :disabled="role===3"  v-model="itemp.rma_solution" placeholder="please choose" @change="((val)=>{solutionchange(val, index)})"  >
                                                <el-option

                                                        v-for="item in setForm.rma_solution"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </td>

                                        <!--<td><el-input :disabled="role===3"  v-model="itemp.delivery_information" type="textarea" class="autotextarea"  :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>-->
                                        <td style="max-width: 200px">{{itemp.delivery_information}}</td>
                                        <td>
                                            <el-select :disabled="role===3" v-model="itemp.warranty_status" placeholder="please choose">
                                                <el-option
                                                        v-for="item in setForm.warranty_status"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </td>
                                    </tr>

                                </table>
                            </el-collapse-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" >
                        <el-col :span="24">

                            <el-collapse-item title="Progress Update (For Customer Feedback)" name="8" class="printMe">
                                <table class="customer-account product-details">
                                    <tr>
                                        <th style="max-width: 60px">Update Date</th>
                                        <!--<th>Update by</th>-->
                                        <th  style="max-width: 80px">RMA Number</th>
                                        <th>Servicing Record </th>
                                        <th>Corrective Action</th>
                                        <th  style="max-width: 80px">Estimated Return Date</th>
                                    </tr>

                                    <tr  v-for="(itemp,index) in rmaForm.product">
                                        <td  style="max-width: 60px">
                                            <el-date-picker
                                                    :disabled="role===3"
                                                    v-model="itemp.progress_update_user_date"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="select date">
                                            </el-date-picker>
                                        </td>

                                        <td style="max-width: 80px">{{itemp.serail_no}}</td>
                                        <td>{{itemp.servicing_record}}</td>
                                        <td>{{itemp.corrective_action}}</td>
                                        <td  style="max-width: 80px">
                                            <el-date-picker
                                                    :disabled="role===3"
                                                    v-model="itemp.estimated_return_date"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="select date">
                                            </el-date-picker>
                                        </td>
                                    </tr>

                                </table>
                            </el-collapse-item>
                        </el-col>
                    </el-row>
                </el-collapse>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getPdf">确 定</el-button>
          </span>
        </el-dialog>

    </div>
</template>

<script>
    var token =  localStorage.getItem('token')
    import autosize from 'autosize';
    import html2Canvas from 'html2canvas'
    import JsPDF from 'jspdf'
    export default {
        name: "rmaAdd.vue",
        data(){
            return{
                screenWidth: document.body.clientWidth-310 + "px",
                isdowning:false,
                rmaForm:{
                },
                pdfhtmlv:true,
                submiting:false,
                oldrmaForm:{},
                adress:{},
                fileList1:[],
                dialogVisible:false,
                addtrue:false,
                activeNames:["1","2","3","4","5","6","7","8","9","10"],
                setForm:{},
                temp:"",
                role:"",
                status1:'',
                fileList:[],
                fileList2:[],
                fileList3:[],
                fileList4:[],
                myHeaders: {token: token},
                link:[],
                rules:{},
                emailtag:{rma_registration:0,rma_response:0,shipping1:0,progress:0,shipping2:0,c_register_sun:0,c_register_cou:0},

            }

        },
        created() {
            this.role=parseInt(localStorage.getItem("role"));
            let id = this.$route.params.id;
            this.getInfo(id);
            this.setForm =  JSON.parse(localStorage.getItem('setform'));
            this.getAdressInfo();
            this.getAds();
        },
        methods:{

            async add() {
                    this.submiting=true
                    const result=await this.$http.post("rma/edit",this.rmaForm);
                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        this.$router.push('/rmaList');
                        const tag=result.data.data.tag;
                        for (let key  in tag){
                            if(tag[key]===1){
                                var obj=new Object();
                                obj[key]=1;
                                await this.$http.post("rma/send",{sendtag:obj,data:result.data.data.res});
                            }
                        }

                    }
            },

            async getPdf () {
                var cloneDom=this.$refs.pdfhtml;
                var title = this.rmaForm.rma_number;
                html2Canvas(cloneDom, {
                    allowTaint: true
                }).then(function (canvas) {

                        let contentWidth = canvas.width
                        let contentHeight = canvas.height
                        let pageHeight = contentWidth / 592.28 * 841.89
                        let leftHeight = contentHeight
                        let position = 0
                        let imgWidth = 595.28
                        let imgHeight = 592.28 / contentWidth * contentHeight
                        let pageData = canvas.toDataURL('image/jpeg', 1.0)
                        let PDF = new JsPDF('', 'pt', 'a4')
                        if (leftHeight < pageHeight) {
                            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
                        } else {
                            while (leftHeight > 0) {
                                PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                                leftHeight -= pageHeight
                                position -= 841.89
                                if (leftHeight > 0) {
                                    PDF.addPage()
                                }
                            }
                        }
                        PDF.save(title + '.pdf')

                    }
                )
                this.dialogVisible=false;



            },


            async getInfo(id){
                const result=await this.$http.get("rma/info/"+id);
                if (result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.rmaForm=result.data.data;
                    this.oldrmaForm = JSON.parse(JSON.stringify(result.data.data));
                    this.status1=result.data.data.status;
                    this.rmaForm.status=result.data.data.status.toString();


                }
            },
            async getAds(){
                const result=await this.$http.get("adress/getAds");
                if (result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {

                    this.adress=result.data.data

                }
            },
            async getAdressInfo(){
                const result=await this.$http.get("adress/info");
                if (result.data.error_code!==0){
                }else {
                    this.adress=result.data.data;
                }

            },



            async handleRemove1(file, fileList1,index,tag) {

                this.rmaForm.product[index][tag].splice(this.rmaForm.product[index][tag].indexOf(file.url),1);
            },
            handleSuccess1(response, file, fileList1,index,tag){

                if(response.error_code !== 0){
                    this.$message.error(response.msg);

                }else {
                    this.rmaForm.product[index][tag].push(response.data);

                }
            },
            handlePreview1(file) {
            },
            handleExceed1(files, fileList1) {
                this.$message.warning(`Limit to select 1 files, this time selected ${files.length} Files, selected ${files.length + fileList1.length} files selected`);
            },
            beforeRemove1(file, fileList) {
                return this.$confirm(`remove ${ file.name }？`);
            },





            async downloaddocs(type,id){
                this.isdowning=true;
                const res=await this.$http.get("file/download/"+ id + "/" + type,{responseType: 'blob'});
                const content = res.data
                const blob = new Blob([content],{type:"application/zip"})

                const fileName = type + id +'.zip'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = window.URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    window.URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }

                this.isdowning=false;
            },
            test(){

                let myCollection=document.getElementsByClassName("autotextarea");
            },

             solutionchange(val,index){
                var key=val.replace(/\s+/g,"");
                this.rmaForm.product[index].delivery_information=this.adress[key];
            },
            geturl(){
                return this.$http.defaults.baseURL + "file/upload"
            },
        },
        watch: {


        },
        mounted() {
                this.$nextTick(function () {
                    // autosize(document.querySelectorAll('textarea'));
                })
            },
        updated : function(){
            this.$nextTick(function(){
                autosize(document.querySelectorAll('textarea'));
            })
        }
    }
</script>

<style lang="less">

    .el-table{

    }
    .el-breadcrumb{
        padding-top: 10px;
    }
    .el-card{
        margin-bottom: 5px;
    }
    .el-table{
        margin-bottom: 5px;
    }
    .el-table-column{
        padding-left: 10px;
    }
    .el-form{
        width: 100%;
    }
    .el-select{
        width: 100%;
    }
    .option2 i{
        margin: 0 7px;
        font-size: 24px;
        color: #008080;
    }
    #mainbody{


        .customer-account td{
            text-align: right;
            padding: 1px;
            background-color: #f1f1f1;
            border: 1px solid #9b9598;
        }
        .el-textarea.is-disabled .el-textarea__inner{
            color: #000000 !important;
        }
        .el-select .el-input.is-disabled .el-input__inner{
            color: #000000 !important;
        }
        .el-input.is-disabled .el-input__inner{
            color: #000000 !important;
        }
        .customer-account th{
            text-align: left;
            padding: 1px;
            background-color: #f1f1f1;
            border: 1px solid #9b9598;
        }
        .product-details td{
            border-left: none;
            border-right: none;
        }
        .el-date-picker{
            width: 100%;
            cursor: pointer;
            .el-input__inner{
                cursor: pointer;
            }



        }
        .el-input__prefix{
            left: 87% !important;

        }
        .el-select /deep/ .el-input__suffix /deep/ .el-input__icon{
            line-height: 20px;
        }
        .product-details{
            textarea{
                padding: 0;

            }
            i{
                font-size: 15px;
            }
            .el-upload{
                float: right;
            }
            .el-upload-list{
                width: 65%;
                float: right;
                ul{
                    padding: 0;
                }
                li{
                    padding: 0;
                    margin: 0;
                }
            }
            button {
                height: 25px;
                padding: 0;
                background-color: #efeff0;
                color: #000000;
                border: none;
            }

        }


        .customer-account {
            width: 100%;
            border-collapse:collapse;
        }

        .customer-account .el-input__inner{
            line-height: 20px;
            height: 20px !important;
            border:none;
            margin: 0;
            padding: 0;
            background-color: #ffffff;
        }

        .customer-account .el-input{
            height: 20px;
            border:none;
            margin: 0;
            padding: 0px;
        }
        .el-collapse-item__header{
            padding-left: 5px;
            background-color: black;
            color: white;
            height: 20px;
        }
        .color-green{
            .el-collapse-item__header{
                background-color: #33ca01;
                color: black;
            }
        }
        .color-red {
            .el-collapse-item__header{
                background-color: #fd0001;
                color: #ffffff;
            }
        }
        .customer-account-header{
            .el-collapse-item__header{
                // border-radius: 10px 0 0 0;
            }
        }

        .rma-status-header{
            .el-collapse-item__header{
                background-color: #4b83bd;
            }
        }
        .el-date-editor{
            width: 100% !important;
        }
        /*.bgred{*/
            /*background-color: red !important;*/
        /*}*/
        textarea{

            width: 100% !important;
        }


        .printMe td{
            padding: 0 5px 0 5px;
            text-align: left;
            border: black 1px solid;
            height: 24px !important;
        }
        #pdfdiv{
            padding: 50px 10px 0 10px;
        }
    }

</style>
